import client from "app/client";

export interface BorrowerProjectDocumentVersionDto {
  versionNumber: number;
  storedFileId: string;
  fileName?: string;
  uploadDate: string;
  isCurrent: boolean;
}

export interface BorrowerProjectDocumentDto {
  fileType: number;
  label?: string;
  storedFileId?: string | null;
  fileName?: string;
  uploadDate?: string;
  versions: BorrowerProjectDocumentVersionDto[];
}

export interface GetBorrowerProjectDocumentsResponse {
  documents: BorrowerProjectDocumentDto[];
}

export interface UploadBorrowerProjectDocumentsResponse {
  isSuccess: boolean;
  errorMessage?: string | null;
}

/**
 * Documents uploadés au niveau du projet d'emprunt (offre de prêt, tableau
 * d'amortissement) avec leur historique de versions.
 */
export async function getBorrowerProjectDocuments(
  borrowerProjectId: string
): Promise<GetBorrowerProjectDocumentsResponse> {
  return (
    await client.get(
      `/backoffice/emprunteurs/projets-emprunts/${borrowerProjectId}/documents`
    )
  )?.data;
}

/**
 * Upload d'un lot de documents d'un type donné sur le projet d'emprunt.
 * Le lot REMPLACE tous les documents existants du même type.
 */
export async function uploadBorrowerProjectDocuments(
  borrowerProjectId: string,
  fileType: number,
  files: File[]
): Promise<UploadBorrowerProjectDocumentsResponse> {
  const formData = new FormData();
  files.forEach((file) => formData.append("files", file));
  return (
    await client.post(
      `/backoffice/files/projets-emprunts/${borrowerProjectId}/type/${fileType}`,
      formData,
      // Timeout élargi : le lot peut contenir plusieurs PDF volumineux.
      { timeout: 60000 }
    )
  )?.data;
}
